<template>
    <div v-show="isShow" :style="domStyle">
        <div class="map"></div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(this.OnCiclk && this.OnCiclk != "%OnClick%"){
            this.OnCiclk = AsyncFunction("param",this.OnCiclk);
        };
    },
    mounted() {
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            opts : {
                width : 200,     // 信息窗口宽度
                height: 80,     // 信息窗口高度
                title : "信息窗口" , // 信息窗口标题
                enableMessage:true//设置允许信息窗发送短息
            },
            isopen:true
        }
    },
    methods : {
        inits(){
            this.map = new BMap.Map(this.$el.childNodes[0],{minZoom:4,maxZoom:19});
            if(this.centerPoint){
                var centerPoint = this.centerPoint.split('/');
                var point = new BMap.Point(centerPoint[0],centerPoint[1]);
                this.map.centerAndZoom(point,this.level);
            }else{
                var point = new BMap.Point(116.404,39.915);
                this.map.centerAndZoom(point,6);
            }
            this.map.enableScrollWheelZoom();
            this.mapType1 = new BMap.MapTypeControl(        //开启卫星图配置
                {
                    mapTypes: [BMAP_NORMAL_MAP,BMAP_HYBRID_MAP],
                    anchor: BMAP_ANCHOR_TOP_LEFT
                }
            );  
            this.updateMarker();
        },
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            // for(var i =0;i<this.coordinates.length;i++){
            //     this.coordinates[i].value = this.fvSystemApi.getReal(this.coordinates[i].dbVar.replace(/\\/g,"."));
            //     console.log(this.coordinates[i].value)
            // }
            // var newTime= new Date().getTime();
            // var time_sec = parseInt(Math.floor(newTime/1000));
            // var dataTime = parseInt(Math.floor(this.tempDataTime/1000));
            // if(time_sec>dataTime&&(time_sec-dataTime)%this.timeStep==0&&time_sec!=this.oldTime){
            //     var listNumb = this.fvSystemApi.getReal(this.coordinates[i].dbVar);
            //     console.log(listNumb)
            //     this.oldTime=time_sec;
            // }
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            // map地图 定位中心位置 不对。 不知道什么导致， 目前第一次延迟绘制。
            if(this.isopen){
                setTimeout(()=>{
                    this.inits();
                },2000);
                this.isopen = false;
            }else{
                this.inits();
            }
            
            
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无
            作用：更新地图标识位置
        */
        updateMarker(){
            this.coordinates.forEach((el) => {
                var marker = new BMap.Marker(new BMap.Point(el.lng, el.lat));
                this.map.addOverlay(marker);
                //鼠标点击
                marker.addEventListener("click", function (e) { 
                    var lng = e.target.getPosition().lng;
                    var lat = e.target.getPosition().lat;
                    for(var i = 0 ; i < this.coordinates.length ; i++ ){
                        if(lng == parseFloat(this.coordinates[i].lng) && lat == parseFloat(this.coordinates[i].lat)){
                            var content = this.coordinates[i].title || "";
                        }
                    }
                    if(typeof this.OnCiclk == "function"){
                        this.fvSystemApi.executionScript(this.OnCiclk,content);
                    };
                }.bind(this));
                //鼠标移入
                marker.addEventListener("mouseover", function (e) { 
                    var lng = e.target.getPosition().lng;
                    var lat = e.target.getPosition().lat;
                    var localtion = new BMap.Point(lng,lat);
                    
                    this.open = setInterval(function(){
                        for(var i = 0 ; i < this.coordinates.length ; i++ ){
                            if(lng == parseFloat(this.coordinates[i].lng) && lat == parseFloat(this.coordinates[i].lat)){
                                // this.opts.title = '<b sytle=color:'+this.coordinates[i].titleColor+'>'+this.coordinates[i].title+'</b>';
                                var a ="rgb(153, 86, 86)";
                                this.opts.title = `<b style="color: ${this.coordinates[i].titleColor};font-size: ${this.coordinates[i].titleSize}px;"> ${this.coordinates[i].title}</b>`
                                this.opts.height= this.coordinates[i].dbVar.length*30;//根据多少条显示设置多高
                                var arr=[];
                                for( var o in this.coordinates[i].dbVar){
                                    var text = this.coordinates[i].info[o]+":"+listNumb;
                                    arr.push(text.length)
                                }
                                this.opts.width=Math.max(arr)*10;
                                var html = "";
                                for( var k in this.coordinates[i].dbVar){
                                    var listNumb = this.fvSystemApi.getReal(this.coordinates[i].dbVar[k].replace(/\\/g,"."));
                                    listNumb = listNumb? listNumb.PV : 0;
                                    html += `<p style="color: ${this.coordinates[i].textColor};font-size: ${this.coordinates[i].textSize}px;">${this.coordinates[i].info[k]}:${listNumb}</p>`;
                                }
                            }
                        }
                        var infoWindow = new BMap.InfoWindow(html,this.opts);
                        this.map.openInfoWindow(infoWindow,localtion);
                    }.bind(this),1000);

                }.bind(this));
                //鼠标移出
                marker.addEventListener("mouseout", function (e) { 
                    clearInterval(this.open);
                    var p = e.target;
                    var localtion = new BMap.Point(p.getPosition().lng,p.getPosition().lat);
                    var infoWindow = new BMap.InfoWindow("8888",this.opts);
                    this.map.closeInfoWindow(infoWindow,localtion);
                }.bind(this));
                
            })
            var arr = [];
            for(var i in  this.polylineArr){
                arr.push(new BMap.Point( this.polylineArr[i].lng, this.polylineArr[i].lat))
            }
            var polyline = new BMap.Polyline(arr,{
                strokeColor:this.borderColors, 
                strokeWeight:this.borderWidths, 
                strokeOpacity:this.borderOpacity,
                enableMassClear:true,
            });
            this.map.addOverlay(polyline);

            for(var k  in this.Polyline){
                var arr = [];
                for(var i in  this.Polyline[k].polylineArr){
                    arr.push(new BMap.Point( this.Polyline[k].polylineArr[i].lng, this.Polyline[k].polylineArr[i].lat))
                }
                var polyline = new BMap.Polyline(arr,{
                    strokeColor:this.Polyline[k].borderColors, 
                    strokeWeight:this.Polyline[k].borderWidths, 
                    strokeOpacity:parseFloat(this.Polyline[k].borderOpacity),
                    enableMassClear:true
                });
                polyline.name = this.Polyline[k].linName;

                // var label = new BMap.Label(this.Polyline[k].linName,{offset:new BMap.Size(0,0)});
                // var markerLin = new BMap.Marker(new BMap.Point(this.Polyline[k].polylineArr[0].lng,this.Polyline[k].polylineArr[0].lat));
                // this.map.addOverlay(markerLin);
                // markerLin.setLabel(label);
                polyline.addEventListener("mouseover", function (e) { 
                }.bind(this));
                polyline.addEventListener("mouseout", function (e) {
                })
                this.map.addOverlay(polyline);
            }
            
            
        },
        /*
            参数：无
            作用：开启地图是否展示卫星图
        */
        openSatelliteImagery(){
    		this.map.addControl(this.mapType1);          //2D图，混合图
        },
        /*
            参数：无
            作用：关闭地图卫星图展示
        */
       closeSatelliteImagery(){
           this.map.removeControl(this.mapType1);   //移除2D图，混合图
       },
        /*
            参数 : 暂无
            作用： 执行组件事件
        */
        onClick(data){
            if(typeof this.Click == "function"){
               this.fvSystemApi.executionScript(this.Click,"data");
            }
        },
    }
}
</script>

<style scoped>
    .map{
        width:100%;
        height:100%;
    }
    .map>>>.anchorBL {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvMap/fvMap.vue